import { isObject } from "lodash";
import isdFooter from "../components/common/isdFooter";
import constMap from "../const/const";
import rootScope from "../store/rootScopeStore";
import { isEmpty, isNotEmpty, isUndefined } from "./util";
import $ from 'jquery';
import { useEffect } from 'react';
import useIsMobile from "./useIsMobile";

let isMobile;
const FunctionKey = () => {
    isMobile = useIsMobile();
    useEffect(() => {
        $("body").keydown(function (event) {
            // F1~F12,ESCの入力をチェック
            if (isMobile) return;
            if ((constMap.keynameCode["F1"] <= event.keyCode && event.keyCode <= constMap.keynameCode["F12"])
                || event.keyCode === constMap.keynameCode["ESC"]) {

                // ローディングマスク表示中は処理しない
                if (isEmpty(rootScope) || rootScope.loading) return;

                // F1~F4 F9~F10,F12は本来のイベントをキャンセルする
                if (constMap.keynameCode["F11"] != event.keyCode
                    && !(constMap.keynameCode["F5"] <= event.keyCode && event.keyCode <= constMap.keynameCode["F8"])) {
                    event.preventDefault();
                }
                // モーダルが存在する場合、モーダルのフッタを処理
                const modalNum = rootScope.modalScopes.length;
                const targetScope = !modalNum ? rootScope : rootScope.modalScopes[modalNum - 1];
                targetScope.pageType = 'F';
                const targetFooter = targetScope.footer;

                // scopeからsearchを取得
                if ($("button.btn").text().indexOf("検索") != -1) {
                    // html上に検索ボタンがある場合に限り処理する
                    // 検索
                    if (doOrNotByKey(constMap.btnView.search, () => { }, targetScope.pageType, modalNum ? targetScope.model : null)) return;
                }
                // モーダルがある場合
                if (modalNum) {
                    // OKダイアログ、確認ダイアログ
                    if (isNotEmpty(targetScope.okView)) {
                        doOrNotByKey(constMap.btnView.dialogOk, targetScope.confirm, targetScope.pageType, targetScope.model);
                        doOrNotByKey(constMap.btnView.dialogCancel, targetScope.cancel, targetScope.pageType, targetScope.model);
                        return;
                    }

                    // クリアボタン
                    const clearBtnTmp = targetFooter.clearBtn;
                    // 属性を確認
                    if (clearBtnTmp && !clearBtnTmp.clearBtnDisabledFlg) {
                        // クリア
                        if (doOrNotByKey(constMap.btnView.clear, clearBtnTmp.func, targetScope.pageType, targetScope.model)) return;
                    }
                    // 実行関数
                    let doFunc = null;
                    // 終了ボタン
                    const endBtnTmp = targetFooter.endBtn;
                    if (!targetScope.endBtnFunc) {
                        doFunc = endBtnTmp.func;
                    } else {
                        doFunc = targetScope.endBtnFunc;
                    }
                    doOrNotByKey(constMap.btnView.end, doFunc, undefined, targetScope.model)
                    // 確定ボタン
                    const commitBtnTmp = targetFooter.commitBtn;
                    // 実行関数
                    doFunc = null;
                    if (commitBtnTmp && commitBtnTmp.func) {
                        doFunc = commitBtnTmp.func;
                    }
                    // 確定
                    if (doOrNotByKey(constMap.btnView.commit, doFunc, targetScope.pageType, targetScope.model)) return;

                    // 詳細ボタン
                    const detailBtnTmp = targetFooter.detailBtn;
                    // 実行関数
                    doFunc = null;
                    if (detailBtnTmp && detailBtnTmp.func) {
                        doFunc = detailBtnTmp.func;
                    }
                    // 詳細
                    if (doOrNotByKey(constMap.btnView.detail, doFunc, targetScope.pageType, targetScope.model)) return;

                    // モーダルがない場合
                } else {
                    // フッタオブジェクトがある場合
                    if (isNotEmpty(targetFooter)) {
                        // 終了ボタン
                        const endBtnTmp = targetFooter.endBtn;
                        // 属性を確認
                        if (!endBtnTmp || isUndefined(endBtnTmp.hide) || !endBtnTmp.hide) {
                            // 実行関数
                            let doFunc = null;
                            if (!endBtnTmp || isUndefined(endBtnTmp.func)) {
                                // デフォルト関数
                                doFunc = isdFooter.footerEndBtnDef.func;
                            } else {
                                doFunc = endBtnTmp.func
                            }

                            // 終了
                            if (doOrNotByKey(constMap.btnView.end, doFunc, targetScope.pageType)) return;
                        }

                        // クリアボタン
                        const clearBtnTmp = targetFooter.clearBtn;
                        // 属性を確認
                        if (clearBtnTmp && !clearBtnTmp.clearBtnDisabledFlg) {
                            // クリア
                            if (doOrNotByKey(constMap.btnView.clear, clearBtnTmp.func, targetScope.pageType)) return;
                        }

                        // 確定ボタン
                        const commitBtnTmp = targetFooter.commitBtn;
                        // 属性を確認
                        if (commitBtnTmp && !commitBtnTmp.commitBtnDisabledFlg && !targetFooter.ctrlScope.requireDisabledFlg && !commitBtnTmp.hide) {
                            // 確定
                            if (doOrNotByKey(constMap.btnView.commit, isdFooter.footerSubmitBtnDef.func, targetScope.pageType)) return;
                        }

                        // otherボタン
                        if (targetFooter.otherBtn) {
                            targetFooter.otherBtn.forEach((btn, index) => {
                                if (doOrNotByKey(btn.view, btn.func, targetScope.pageType)) return;
                            });
                        }
                    }
                }
            }

            // 実行不実行処理
            function doOrNotByKey(name, func, pageType, model) {
                // 名前または関数が定義されていない場合、中止
                if (isEmpty(name) || isEmpty(func)) return;
                // ショートカット情報取得
                const shortcut = constMap.btnShortcut[name];
                if (isEmpty(shortcut)) return;
                const shortcutVal = isObject(shortcut) ? shortcut[isUndefined(pageType) ? 'F' : pageType] : shortcut;

                // キー値が一致していたら実行
                if (event.keyCode == constMap.keynameCode[shortcutVal]) {
                    // 一致するボタンが存在する場合はフォーカスをボタンに移動する
                    let btnDisabled = false;
                    let btnElement = null;
                    const contailers = model ? document.querySelectorAll(`.${model}`) : document.querySelectorAll('.page-menu-bottom');
                    if (name == "検索" && !model) {
                        document.querySelector('.container').querySelectorAll('button').forEach(btn => {
                            if (btn.innerText.startsWith(name)) {
                                btnElement = btn;
                                btnDisabled = btn.disabled;
                            }
                        });
                    } else if (contailers && contailers.length) {
                        contailers[contailers.length - 1].querySelectorAll('button').forEach(btn => {
                            if (btn.innerText.startsWith(name)) {
                                btnElement = btn;
                                btnDisabled = btn.disabled;
                            }
                        });
                    }
                    // ボタンが非活性の場合何もしない
                    if (btnDisabled) return true;
                    // フォーカス移動が発生した場合
                    if (name == "検索" && btnElement) {
                        btnElement.click();
                    } else {
                        func();
                    }
                    return true;
                }
                return false;
            }
        })
    }, []);
}

export default FunctionKey;